import React, { Fragment, useEffect, useRef, useState } from "react";
import MyCard from "../../../tools/MyCard";
import { BorderButton } from "../../../global/BorderButton";
import {
  Calendar,
  Calendar1,
  Check,
  Cross,
  Dot,
  Eye,
  EyeOff,
  Key,
  LogOut,
  Pencil,
  ShieldCheck,
  Upload,
  User,
  X,
} from "lucide-react";
import { SolidButton } from "../../../global/SolidButton";
import {
  changePassword,
  updateProfile,
  uploadAvatar,
  userProfile,
} from "../api";
import MyLoader from "../../../util/MyLoader";
import { formatDateTime } from "../../../util/MDate";
import { MyModal } from "../../../global/MyModal";
import toast from "react-hot-toast";
import { useUserStore } from "../../../../store/useUserStore";

export default function Account() {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [name, setName] = useState("");
  const fileInputRef = useRef(null);
 // const [fileSize, setFileSize] = useState("");
  const [avatar, setAvatar] = useState(null);
  const [errors, setErrors] = useState({});
  const [isDisabled, setDisabled] = useState(false);
  // password--------------------------
  const [isPswModalOpen, setIsPswModalOpen] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState(null);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [newPassword, setNewPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [imageUrl,setImageUrl]=useState("");

  const setNameP = useUserStore((state) => state.setName);
  const setRoleP = useUserStore((state) => state.setRole);

  const fetchProfile = async () => {
    try {
      const res = await userProfile();
      if (res.status === 200) {
        const data = res?.data;

        setProfileData(data);
        setName(data.name);
        setAvatar(data.avatar);
        setNameP(data.name);
        setRoleP(data.role);
      }
    } catch (err) {
      console.error("failed to fetch profile :", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];

    if (!allowedTypes.includes(file.type)) {
      toast("Only PNG, JPG, JPEG files are allowed");
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      toast("File size must be less than 2MB");
      return;
    }

   

    const reader = new FileReader();

    reader.onload = async () => {
      //hit api for upload image

      try {

        const repTxt = name.replace(/\s+/g, "_");
        const res = await uploadAvatar({
          userName: repTxt,
          file: file,
        });
        const data = res?.data;
        if (data.success) {
          setAvatar(reader.result);
          setImageUrl(data.url);
        }
      } catch (err) {
        console.error(err);
      }
    };

    reader.readAsDataURL(file); // ✅ FIXED
  };

  
  const validateForm = () => {
    const errs = {};
    if (name === "") {
      errs.name = "Name is required";
    }

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const validatePassword = () => {
    const errs = {};
    if (currentPassword === null) {
      errs.currentPassword = "Current Password is required";
    }
    if (newPassword === null) {
      errs.newPassword = "New Password is required";
    }
    if (newPassword.length < 6) {
      errs.newPassword = "Password should be greater than 6 chars";
    }
    if (confirmPassword === null) {
      errs.confirmPassword = "Confirm Password is required";
    }
    if (confirmPassword != newPassword) {
      errs.confirmPassword = "Confirm Password is not match";
    }

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };
  const setAvatarP = useUserStore((state) => state.setAvatar);
  const savedImage = useUserStore((state) => state.avatar);

  const handleSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!validateForm()) return;
    const payload = {
      name: name,
      avatar: imageUrl,
    };

    const updateUserProfile = async () => {
      try {
        const res = await updateProfile(payload);
        if (res.status === 200) {
          toast.success("Profile updated successfully");
          setAvatar(avatar);
          setErrors({});
          setDisabled(false);
          setIsModalOpen(false);
          fetchProfile();
          setAvatarP(avatar);
        
        }
      } catch (err) {
        setDisabled(false);
        console.error("Failed to update profile", err);
      }
    };
    updateUserProfile();
  };
  const handleSubmitPassword = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!validatePassword()) return;
    const payload = {
      old_password: currentPassword,
      new_password: newPassword,
    };

    const updateUserPass = async () => {
      try {
        const res = await changePassword(payload);
        if (res.status === 200) {
          toast.success("Password changed successfully");

          setErrors({});
          setDisabled(false);
          setIsPswModalOpen(false);
        }
      } catch (err) {
        setDisabled(false);
        console.error("Failed to change password", err);
      }
    };
    updateUserPass();
  };

 

  if (loading) return <MyLoader />;

  return (
    <Fragment>
      <div className="space-y-2 grid grid-cols-1 lg:grid-cols-10  sm:grid-cols-1 gap-6 px-20">
        {/* first section */}
        <div className="w-full col-span-6 h-fit ">
          {/* Profile Information */}
          <MyCard className=" p-6 ">
            <div className="flex items-center justify-between">
              <span className="text-sm text-slate-800 dark:text-slate-100  font-bold">
                Profile Information
              </span>
              <BorderButton onClick={() => setIsModalOpen(true)}>
                <Pencil className="w-4 h-4 text-slate-500 dark:text-slate-100" />
                <span className="text-xs text-slate-600 dark:text-slate-100">
                  Edit Profile
                </span>
              </BorderButton>
            </div>
            <div className="flex items-start justify-start space-x-6 mt-6">
              <img
                className="w-20 h-20 rounded-full"
                src={
                  !savedImage
                    ? "https://images.pexels.com/photos/2693814/pexels-photo-2693814.jpeg"
                    : savedImage
                }
                alt=""
              />
              <div className="flex flex-col items-start ">
                <span className="text-[10px] font-medium text-slate-600 dark:text-slate-300 uppercase">
                  Full Name
                </span>
                <span className="text-xs font-semibold text-slate-900 dark:text-slate-50  mt-1">
                  {profileData.name}
                </span>
                <span className="text-[10px] font-medium text-slate-600 dark:text-slate-300 mt-4 uppercase">
                  Email Address
                </span>
                <span className="text-xs font-semibold text-slate-900 dark:text-slate-50 mt-1">
                  {profileData.email}
                </span>
                <p className="text-[9px] font-normal text-slate-500  dark:text-slate-400 mt-1">
                  Email can not be changed
                </p>
                <span className="text-[10px] font-medium text-slate-600 dark:text-slate-300 mt-4 uppercase">
                  Role/Label
                </span>
                <span className="text-xs font-semibold text-slate-900 dark:text-slate-50 mt-1">
                  {profileData.role}
                </span>
                <span className="text-[10px] font-medium text-slate-600 dark:text-slate-300 mt-4 uppercase">
                  AUTHENTICATION PROVIDER
                </span>
                <span className="text-xs font-semibold dark:text-slate-50 text-slate-900 mt-1">
                  Email
                </span>
                <SolidButton
                disabled={isDisabled}
                  onClick={() => {
                    // Clear invalid token
                    localStorage.removeItem("token");
                    localStorage.removeItem("appToken");
                    // Redirect to login page
                    window.location.href = "/login";

                  }}
                  className="mt-6 bg-red-600/10 border-red-500 border hover:bg-red-300/50"
                >
                  <LogOut className="w-4 h-4 text-red-500" />
                  <span className="text-red-500 text-xs font-medium ">
                    Logout
                  </span>
                </SolidButton>
              </div>
            </div>
          </MyCard>
          {/* change password */}
          <MyCard className="p-6 mt-5 flex flex-col ">
            <div className="flex items-center justify-start space-x-4">
              <Key className="w-8 h-8 text-blue-500 rounded-full bg-blue-500/20 p-2" />
              <div className="flex flex-col">
                <span className="text-sm text-slate-600 dark:text-white font-semibold">
                  Password
                </span>
                <span className="text-xs font-normal text-slate-500 dark:text-slate-300">
                  Change your Account Password
                </span>
              </div>
              <div className="ml-auto  text-slate-800 dark:text-white">
                <BorderButton onClick={() => setIsPswModalOpen(true)}>
                  <Key className=" w-4 h-4" />
                  <span className="text-xs">Change Password</span>
                </BorderButton>
              </div>
            </div>
            <span className="text-[11px] text-slate-600 dark:text-slate-400 font-normal mt-4">
              Use a strong password with at least 6 characters to keep your
              account secure.
            </span>
          </MyCard>
          {/* Tow fector authentication */}
          <MyCard className="p-6 mt-5 flex flex-col ">
            <div className="flex items-center justify-start space-x-4">
              <ShieldCheck className="w-8 h-8 text-green-500 rounded-full bg-green-500/20 p-2" />
              <div className="flex flex-col">
                <span className="text-sm text-slate-600 font-semibold dark:text-white">
                  Tow-Fector Authentication
                </span>
                <span className="text-xs text-slate-500 dark:text-slate-300">
                  Your account is protected with 2FA
                </span>
              </div>
              <div className="ml-auto  text-slate-800">
                {/* Enable Button */}
                <button
                  disabled={!profileData.two_fa}
                  className={`flex items-center justify-start space-x-2 border disabled:bg-blue-500/20 disabled:border-blue-500 disabled:text-blue-500
                   text-green-600 border-green-500 rounded-lg p-2 bg-green-500/20`}
                >
                  {profileData.two_fa ? (
                    <Check className=" w-4 h-4" />
                  ) : (
                    <X className=" w-4 h-4" />
                  )}

                  <span className="text-xs">
                    {profileData.two_fa ? "Enable" : "Disable"}
                  </span>
                </button>
              </div>
            </div>
            <span className="text-[11px] text-slate-600 font-normal dark:text-slate-400 mt-4">
              Two-factor authentication is active. You can manage your 2FA
              settings in the security page.
            </span>
          </MyCard>
        </div>
        {/* second section */}
        <div className="w-full lg:col-span-4 h-fit">
          {/* Account Activity */}
          <MyCard className="p-5 w-full">
            <span className="text-sm text-slate-800 font-bold dark:text-white">
              Account Activity
            </span>
            {/* Joined Date */}
            <div className="flex items-center justify-start space-x-2 mt-4">
              <Calendar1 className="w-8 h-8 bg-green-500/20 text-green-500 p-2 rounded-md" />
              <div className="flex flex-col">
                <span className="text-xs text-slate-500 dark:text-slate-300">
                  Date Joined
                </span>
                <span className="text-xs text-slate-800 font-medium dark:text-white">
                  {formatDateTime(profileData.created_at)}
                </span>
              </div>
            </div>
            {/* Last Login */}
            <div className="flex items-center justify-start space-x-2 mt-6">
              <Calendar1 className="w-8 h-8 bg-blue-500/20 text-blue-500 p-2 rounded-md" />
              <div className="flex flex-col">
                <span className="text-xs text-slate-500 dark:text-slate-300">
                  Last Login
                </span>
                <span className="text-xs text-slate-800 dark:text-white font-medium">
                  {formatDateTime(profileData.last_login_at)}
                </span>
              </div>
            </div>
            {/* Last IP Address */}
            <div className="flex items-center justify-start space-x-2 mt-6">
              <Calendar1 className="w-8 h-8 bg-pink-500/20 text-pink-500 p-2 rounded-md" />
              <div className="flex flex-col">
                <span className="text-xs text-slate-500 dark:text-slate-300">
                  Last Login
                </span>
                <span className="text-xs text-slate-800 dark:text-white font-medium">
                  {profileData.last_login_ip}
                </span>
              </div>
            </div>
          </MyCard>
          {/* Account Status */}
          <MyCard className="p-5 mt-4 flex flex-col">
            <span className="text-sm text-slate-800 font-bold dark:text-white">
              Account Status
            </span>
            <div className="flex items-center justify-start mt-2 space-x-2">
              <div className="w-2 h-2 text-green-500 bg-green-500 rounded-full" />
              <span className="text-sm text-slate-600 capitalize dark:text-white ">
                {profileData.status}
              </span>
            </div>
          </MyCard>
        </div>
      </div>
      {/* Edit Propile */}
      <MyModal
        isOpen={isModalOpen}
        title={"Edit Profile"}
        onClose={() => {
          setIsModalOpen(false);
          //setAvatar(null);
        }}
        children={
          <>
            {/* profile */}
            <h1 className=" text-sm  font-medium text-black-600 dark:text-slate-200 mt-4 ">
              Profile Picture
            </h1>
            <div className="w-full flex items-center justify-between space-x-4 mt-2">
              <div className="relative h-14 w-14 overflow-hidden rounded-full">
                {avatar ? (
                  <img
                    className="w-full h-full rounded-full object-cover"
                    src={avatar}
                    alt="profile"
                  />
                ) : (
                  <User
                    className="w-full h-full p-2 text-slate-600 dark:text-slate-300
      bg-slate-400/20 dark:bg-slate-700"
                  />
                )}
              </div>
              {/* file input */}
              <div
                className="relative flex flex-col items-center justify-center space-y-1 border-2
                            border-dashed border-slate-400/50 dark:border-slate-600/50 
                           hover:border-slate-500 dark:hover:border-slate-500
                            rounded-lg p-3 flex-1 cursor-pointer
                             transition-all duration-300 "
              >
                <Upload className="w-6 h-6 text-slate-600 dark:text-slate-400" />
                <span className="text-sm text-slate-600 dark:text-slate-400">
                  Click to upload photo
                </span>
                <span className="text-xs text-slate-600 dark:text-slate-500">
                  PNG,JPG-up to 2MB
                </span>
                {/* Hidden file input */}
                <input
                  type="file"
                  accept=".png,.jpg,.jpeg"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  className="absolute inset-0 w-full h-full opacity-0  bg-amber-500 cursor-pointer"
                />
              </div>
            </div>
            {/* Full Name */}
            <h1 className=" text-sm  font-medium text-black-600 dark:text-slate-200 mt-4 ">
              Full Name*
            </h1>
            <input
              type="text"
              name="userName"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                if (errors.name)
                  setErrors((prev) => ({ ...prev, name: undefined }));
              }}
              placeholder="Enter Full Name"
              id=""
              className={`w-full px-2  py-2 
              bg-slate-100 dark:bg-slate-800 
              border border-slate-200 dark:border-slate-700 
              rounded-md mt-2
              text-slate-800 dark:text-white text-xs
              placeholder-slate-500 focus:outline-none focus:ring-2
              focus:ring-blue-500 focus:border-transparent transition-all ${
                errors.name
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
            />
            {/* Email */}
            <h1 className=" text-sm  font-medium text-black-600 dark:text-slate-200 mt-5 ">
              Email*
            </h1>
            <input
              type="text"
              name="memberEmail"
              placeholder="Enter Email Addreee"
              id=""
              readOnly
              defaultValue={profileData.email}
              // onChange={(e) => setEmail(e.target.value)}
              className="w-full px-2  py-2 
              bg-slate-100 dark:bg-slate-800 
              border border-slate-200 dark:border-slate-700 
              rounded-md mt-2
              text-slate-800 dark:text-slate-400 text-xs
              placeholder-slate-500 focus:outline-none focus:ring-2
              focus:ring-blue-500 focus:border-transparent transition-all"
            />
            <span className="text-[10px] dark:text-slate-500 text-slate-500">
              Email cannot be changed
            </span>

            <div className="bg-slate-500/20 dark:bg-slate-400/20  w-full h-[1px] mt-4" />

            <div className="flex items-center justify-end space-x-4 mt-4">
              <button
                className="px-4 py-2 rounded-lg
             bg-slate-400/20 dark:bg-slate-800 
             text-slate-800 dark:text-slate-300 text-sm font-semibold
             hover:bg-slate-400/30 dark:hover:bg-slate-700 
             transition-all duration-300"
                onClick={() => {
                  setIsModalOpen(false);
                  setAvatar(null);
                }}
              >
                Cancel
              </button>
              <SolidButton
                children={<span>Save Changes</span>}
                onClick={(e) => handleSubmit(e)}
              />
            </div>
          </>
        }
      />
      {/* password change */}
      <MyModal
        isOpen={isPswModalOpen}
        title={"Change Password"}
        onClose={() => {
          setIsPswModalOpen(false);
        }}
        children={
          <>
            <div className="bg-slate-500/20 dark:bg-slate-400/20  w-full h-[1px] mt-4" />
            {/* Current Password */}
            <h1 className=" text-sm  font-medium text-black-600 dark:text-slate-200 mt-5 ">
              Current Password*
            </h1>
            <div className="relative w-full">
              <input
                type={showCurrentPassword ? "text" : "password"}
                name="currentPassword"
                placeholder="Enter Current Password"
                id=""
                value={currentPassword}
                onChange={(e) => {
                  setCurrentPassword(e.target.value);
                  if (errors.currentPassword)
                    setErrors((prev) => ({
                      ...prev,
                      currentPassword: undefined,
                    }));
                }}
                className={`w-full px-2  py-2 
              bg-slate-100 dark:bg-slate-800 
              border border-slate-200 dark:border-slate-700 
              rounded-md mt-2
              text-slate-800 dark:text-white text-sm
              placeholder-slate-500 focus:outline-none focus:ring-2
              focus:ring-blue-500 focus:border-transparent transition-all
                ${
                  errors.currentPassword
                    ? "border-red-400"
                    : "border-slate-200 dark:border-slate-700"
                }
              `}
              />
              <button
                className="absolute right-2 top-1/2  transform -translate-y-1 
              text-slate-400 hover:text-slate-600 dark:hover:text-slate-300
              "
                onClick={() => setShowCurrentPassword(!showCurrentPassword)}
              >
                {showCurrentPassword ? (
                  <EyeOff className="w-4 h-4" />
                ) : (
                  <Eye className="w-4 h-4" />
                )}
              </button>
            </div>
            {/* New Password */}
            <h1 className=" text-sm  font-medium text-black-600 dark:text-slate-200 mt-5 ">
              New Password*
            </h1>
            <div className="relative w-full">
              <input
                type={showNewPassword ? "text" : "password"}
                name="newPassword"
                placeholder="Enter New Password"
                id=""
                value={newPassword}
                onChange={(e) => {
                  setNewPassword(e.target.value);
                  if (errors.newPassword)
                    setErrors((prev) => ({
                      ...prev,
                      newPassword: undefined,
                    }));
                }}
                className={`w-full px-2  py-2 
              bg-slate-100 dark:bg-slate-800 
              border border-slate-200 dark:border-slate-700 
              rounded-md mt-2
              text-slate-800 dark:text-white text-sm
              placeholder-slate-500 focus:outline-none focus:ring-2
              focus:ring-blue-500 focus:border-transparent transition-all
              ${
                errors.newPassword
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }
              `}
              />
              <button
                className="absolute right-2 top-1/2  transform -translate-y-1 
              text-slate-400 hover:text-slate-600 dark:hover:text-slate-300
              "
                onClick={() => setShowNewPassword(!showNewPassword)}
              >
                {showNewPassword ? (
                  <EyeOff className="w-4 h-4" />
                ) : (
                  <Eye className="w-4 h-4" />
                )}
              </button>
            </div>
            <span className="text-[10px] text-slate-400 dark:text-slate-300/70 font-normal">
              Minimum 6 Characters
            </span>
            {/* Confirm Password */}
            <h1 className=" text-sm  font-medium text-black-600 dark:text-slate-200 mt-5 ">
              Confirm Password*
            </h1>
            <div className="relative w-full">
              <input
                type={"text"}
                name="confirmPassword"
                placeholder="Enter Confirm Password"
                id=""
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                  if (errors.confirmPassword)
                    setErrors((prev) => ({
                      ...prev,
                      confirmPassword: undefined,
                    }));
                }}
                className={`w-full px-2  py-2 
              bg-slate-100 dark:bg-slate-800 
              border border-slate-200 dark:border-slate-700 
              rounded-md mt-2
              text-slate-800 dark:text-white text-sm
              placeholder-slate-500 focus:outline-none focus:ring-2
              focus:ring-blue-500 focus:border-transparent transition-all
              ${
                errors.confirmPassword
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }
              `}
              />
            </div>

            <div className="flex items-center justify-end space-x-4 mt-6">
              {/* action btns */}
              <button
                className="px-4 py-2 rounded-lg
             bg-slate-400/20 dark:bg-slate-800 
             text-slate-800 dark:text-slate-300 text-sm font-semibold
             hover:bg-slate-400/30 dark:hover:bg-slate-700 
             transition-all duration-300"
                onClick={() => {
                  setIsModalOpen(false);
                  setAvatar(null);
                }}
              >
                Cancel
              </button>
              <SolidButton
                children={<span>Update Password</span>}
                onClick={() => handleSubmitPassword()}
              />
            </div>
          </>
        }
      />
    </Fragment>
  );
}
